import React from 'react';
import { useState } from 'react';

import Modal from '../../../components/UI/Modal/Modal'
import Helper from '../../../lib/Helper';
import IndicationFull from './IndicationFull';

import styles from './Indications.module.css';

const Indication = (props) => {

  const [showFull, setShowFull] = useState(false);

  return <div className={styles.indication}>
    {showFull && <Modal show={showFull}
      modalClosed={() => { setShowFull(false) }}>
      <IndicationFull indication={props.indication} />
    </Modal>}
    <div className={styles.subject} onClick={() => setShowFull(true)}>
      {Helper.PrintDate(props.indication?.date)} {props.indication?.ref}
    </div>
  </div>
}

export default Indication;

// {props.indication?.pat_first_name} {props.indication?.pat_name}